<template>
  <div
    class="autocomplete-wrapper enext-input"
    :class="[rules && rules.length ? 'enext-input--validable' : '', errorMessage ? 'invalid' : '', $attrs?.class ? $attrs.class : '']"
  >
    <kendo-autocomplete
      v-bind="customAttrs"
      :ref="'autocomplete_validationFormAutocomplete'"
    >
      <template
        v-for="(_, slot) of $slots"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
    </kendo-autocomplete>
    <ErrorMessage
      :error-message="errorMessage"
      class="enext-input__errormessage"
    />
  </div>
</template>

<script>
import {AutoComplete} from '@progress/kendo-vue-dropdowns'
import useInputValidation from '~/composables/useInputValidation'
import ErrorMessage from '~/components/input-components/ErrorMessage'

export default {
  name: 'ComboBoxDropDown',
  inheritAttrs: false,
  components: {
    ErrorMessage,
    'kendo-autocomplete': AutoComplete
  },
  props: {
    rules: {
      type: Array,
      required: false,
      default() {
        return []
      }
    }
  },
  setup(props, {attrs}) {
    const {errorMessage, fallbackValue, validate, getName} = useInputValidation({
      rules: computed(() => props.rules),
      getAttrs: () => attrs
    })

    return {
      errorMessage,
      fallbackValue,
      validate,
      getName
    }
  },
  data() {
    return {
      currentInstanceRef: null
    }
  },
  computed: {
    customAttrs() {
      let attrs = {...this.$attrs, class: ''}
      return attrs
    }
  },
  mounted() {
    this.currentInstanceRef = this.$refs['autocomplete_validationFormAutocomplete']
  },
  methods: {
    focusAutoFocusInput() {
      this.currentInstanceRef?.focus()
    }
  }
}
</script>

<style lang="scss">
.autocomplete-wrapper {
  .k-autocomplete {
    border: none;

    &:focus-within {
      box-shadow: none;
    }
  }

  &.use-loader {
    .k-autocomplete {
      position: relative;

      .k-searchbar input {
        padding-right: 1.5rem;
      }

      .k-i-loading {
        position: absolute;
        right: 0;
        height: 100%;
      }
    }
  }
}
</style>
